import { default as Popper } from 'popper.js';

window.Popper = Popper;

